import { render, staticRenderFns } from "./statCard.vue?vue&type=template&id=535e0cfa&scoped=true"
import script from "./statCard.vue?vue&type=script&lang=js"
export * from "./statCard.vue?vue&type=script&lang=js"
import style0 from "./statCard.vue?vue&type=style&index=0&id=535e0cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535e0cfa",
  null
  
)

export default component.exports